import Header from '~/components/Layout/components/Header';
import Footer from '~/components/Layout/components/Footer';
import {ScrollToTopButton} from '~/components';
function BreakThroughLayout({ children }) {
    return (
        <div>
            <Header />
            <div className="pb-5" style={{ backgroundColor: '#fff' }}>
                {children}
            </div>
            <Footer/>
            <ScrollToTopButton/>
        </div>
    )
}
export default BreakThroughLayout;